import { Outlet } from 'react-router-dom';

import { getIsLoggedIn } from '@dmp/utils';

export const LoginGuard = () => {
  const isLoggedIn = getIsLoggedIn();

  if (!isLoggedIn) {
    return (
      <div className="h-[300px] flex flex-col items-center justify-center">
        <div className="text-[20px] text-[#333]">Login is required to access this page</div>
      </div>
    );
  }

  return <Outlet />;
};
